import styled from '@emotion/styled';
import { Body } from './Body';
import Header from './Header';
import type { PromptModalProps } from './interfaces';
import Modal from './Modal';

type Props =
  PromptModalProps;

export const Prompt = (props: Props) => {

  return (
    <StyledModal
      blocking={props.blocking}
      className={props.className}
      disablePortal={props.disablePortal}
      onClose={props.onClose}
      open={props.visible}>
      <PromptRoot>
        {props.header && <StyledHeader>{props.header}</StyledHeader>}
        {props.body && <StyledBody>{props.body}</StyledBody>}
        {props.footer && <StyledFooter>{props.footer}</StyledFooter>}
      </PromptRoot>
    </StyledModal>
  );
};

export default Prompt;

const PromptRoot = styled.div({
  minHeight: 150,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
});
const StyledHeader = styled(Header)({
  textAlign: 'center',
  margin: '10px auto',
  width: '80%',
});
const StyledBody = styled(Body)({
  margin: '0 auto 20px',
  maxWidth: 400,
});
const StyledFooter = styled.div({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  marginBottom: 30,
});
const StyledModal = styled(Modal)({
  maxWidth: 550,
});